// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"32":"2f5fd8fa","178":"e78feec2"}[chunkId] + ".js";
};